<template id="client-add">
  <div class="maxw">
    <h2>Nou Producte</h2>
    <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col>
          <b-form-group label="Producte:" label-class="font-weight-bold" label-for="input-nombre">
            <b-form-input
                id="input-nombre"
                v-model="form.nombre"
                required
                maxlength = 50
                autofocus
                placeholder="Enter name"
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Descripció:" label-class="font-weight-bold" label-for="input-des">
            <b-form-input
                id="input-des"
                maxlength = 200
                v-model="form.descripcion"
              ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
       <b-col cols="2">
          <b-form-group label="Unitats:" label-class="font-weight-bold" label-for="input-unit">
            <b-form-input
              type="number"
              :number="true"
              step="0.01" min="0.00"
              required
              id="input-unit"
              v-model="form.unitats"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
        <b-form-group label="Preu: (€)" label-class="font-weight-bold" label-for="input-preu">
            <b-form-input
              type="number"
              :number="true"
              required
              id="input-preu"
              v-model="form.precio"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Preu Base: (€)">
              {{ calculaPreu }}
          </b-form-group>
        </b-col>
        <b-col cols="2">
         <b-form-group label="Dte: (%)" label-class="font-weight-bold"  label-for="input-preu">
            <b-form-input
              type="number"
              step="0.01" min="0.00"
              :number="true"
              required
              id="input-preu"
              v-model="form.descuento"
            ></b-form-input>
          </b-form-group>
        </b-col>
       <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Dte: (€)">
              {{ calculaDescompte }}
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label-class="font-weight-bold" label="Import: (€)">
              {{ form.import = calculaImport }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
        <b-form-group label="Dies Facturació:" label-for="input-fact">
            <b-form-input
                id="input-fact"
                type="number"
                :number="true"
                required
                v-model="form.diasFacturacion"
                placeholder="Periode (nombre de dies) de facturació."
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
         <b-form-group label="Repetitiu:" label-for="input-rep">
            <b-form-checkbox v-model="form.isRecurrente" name="check-button" switch>
              Facturació Recurrent (vs Unica) <b>(Checked: {{ form.isRecurrente }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit">Save</b-button>
          <b-button variant="outline-primary"><router-link :to="{ name: 'Productes'}">Cancel</router-link></b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  data () {
    return {
      form: {
        nombre: null,
        descripcion: null,
        precio: null,
        unitats: null,
        descuento: null,
        import: 0,
        diasFacturacion: null,
        isRecurrente: false
      },
      show: true
    }
  },
  computed: {
    calculaPreu: function () {
      return (this.form.precio * this.form.unitats)
    },
    calculaDescompte: function () {
      return (-this.calculaPreu * (this.form.descuento / 100))
    },
    calculaImport: function () {
      return (this.calculaPreu + this.calculaDescompte)
    }
  },
  methods: {
    onSubmit (evt) {
    //   evt.preventDefault()
      //   alert(JSON.stringify(this.form))
      (async () => {
        await DataAccess.postData('/api/products', JSON.stringify(this.form))
          .then(response => {
            this.$router.push({ name: 'Productes' })
          })
          .catch(error => {
            console.log('ERROR: ', error)
          })
      })()
    },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.nombre = ''
      this.form.descripcion = ''
      this.form.precio = 0
      this.form.unitats = 0
      this.form.diasFacturacion = ''
      this.form.isRecurrente = false
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
